/*global jQuery, google */
(function($) {



  'use strict';

  if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
    $('ul.nav li.dropdown').hover(function() {
        $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn('fast');
        return false;
      }, function() {
        $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut('fast');
        return false;
    });
  }
  
  $('.back-button').on('click', function() {
    history.go(-1);
  });

  
  
  $('.gallery').fancybox({
    afterShow : function( instance, current ) {
      console.info( instance );
    }
  });


  $('ul.nav li a.linkmenu').on('click', function() {
    document.location.href = $(this).attr('href');
  });

  $(function() {

    $('.owl-carousel.bannerhome').owlCarousel({
      animateOut: 'fadeOut',
      mergeFit: true,
      responsiveRefreshRate: 200,
      margin : 0,
      loop: true,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      autoplaySpeed: 1000,
      items: 1,
      nav: false,
      dots: false,
      //navText:['<div class="left carousel-control hidden-xs"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span></div>',
      //        '<div class="right carousel-control hidden-xs"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></div>']
    });

    $('body').on('change', '.select-tag', function() {
      document.location.href = $(this).find(':selected').data('href');
    });

    $('body').on('click', '.header-phone', function() {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Phone',
          eventAction: 'click',
          eventLabel: 'header-phone'
        });
    });

  
    $('body').on('click', '.invia-contatto', function() {
      var validator = $('#form-contatto').validate({
        focusInvalid: false,
        onkeyup: false,
        onfocusout: false,
        errorElement: 'p',
        errorPlacement: function(error) {
          var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
          '<h4>' + $(error).html() + '</h4><br>';

          attivaModal(tmpl, ['Chiudi'], ['']);

          $('div#errors').show();
          if ($('div#errors').html() === '') {
            error.appendTo('div#errors');
          }
        },
        rules: {
          nome: {
            required: true
          },
          captcha: {
            required: true
          },
          telefono: {
            required: true
          },
          check_privacy: {
            required: true
          },
          email: {
            required: true,
            email: true
          }
        },
        messages: {
          nome: {
            required: setup.texts.testi['inserire-nome']
          },
          check_privacy: {
            required: setup.texts.testi['check-privacy']
          },
          captcha: {
            required: setup.texts.testi['inserire-captcha']
          },
          telefono: {
            required: setup.texts.testi['inserire-telefono']
          },
          email: {
            required: setup.texts.testi['inserire-mail'],
            email: setup.texts.testi['mail-corretta']
          }
        },
        invalidHandler: function() {
          $('div#errors').html('');
        }
      });

      var arr = {};
      arr.email = $('#email').val();
      arr.telefono = $('#telefono').val();
      arr.tipo = $('#tipo').val();
      arr.nominativo = $('#nome').val();
      arr.messaggio = $('#messaggio').val();
      arr.captcha = $('#captcha').val();

      arr.check_privacy = $('#check_privacy').is(':checked');
      arr.check_commercial = $('#check_commercial').is(':checked');

      arr.idpagina = $('#idpagina').val();
      arr.pagina = $('#pagina').val();
      var jsonString = JSON.stringify(arr);


      if (validator.form()) {
        var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
        '<h4>Stiamo elaborando la sua richiesta, attendere un attimo...</h4><br><br>';
        attivaModal(tmpl, null, null);

        var fd = new FormData();
        fd.append('action', 'invia-contatto');
        fd.append('obj', jsonString);

        $.ajax({
          url: '/ajax/function.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
            var arr = ret.split('|');
            var tmpl = '';

            if (arr[0] === '1') {
              tmpl = '<span class="glyphicon glyphicon-send" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
              $('#email').val('');
              $('#nome').val('');
              $('#privacy').val('');
              $('#telefono').val('');
              $('#messaggio').val('');
              $('#captcha').val('');

              ga('send', {
                hitType: 'event',
                eventCategory: 'Contact',
                eventAction: 'send-email',
                eventLabel: 'compilazione form'
              });

            } else {
              tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            }
            attivaModal(tmpl, ['Chiudi'], [''], null);
          }
        });
        return false;
      }
      return false;
    });


    var attivaModal = function(message, buttons, idButtons, callBack) {
      $('.modal-body p').hide();
      $('.modal-body p').html(message);
      $('.modal-body p').show();

      if (!$('.modal').hasClass('in')) {
        $('.modal').modal('show');
      }

      $('.modal-footer').html('');

      if (typeof buttons !== 'undefined' && buttons !== null) {
        if (buttons.length > 0) {
          $.each(buttons, function(index, value) {
            if (idButtons[index] === '') {
              $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
            } else {
              $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
            }
          });
        }
      }
      if (typeof callBack === 'function') {
        callBack();
      }
    };


  });

  


}(jQuery));


function goToElement(element) {
  $("html, body").animate({ scrollTop: $(element).offset().top }, 1000, function(){
    $(element + ' form .form-control' ).addClass('flash');
    $('#nome').focus().trigger('keydown.autocomplete');
    setTimeout(function(){$('.flash').removeClass('flash');}, 1000);

  });
}

